__turbopack_context__.v({
  "Images": "I2J-1G_Images",
  "Root": "I2J-1G_Root",
  "Root--NoPadding": "I2J-1G_Root--NoPadding",
  "Root--Watchtower": "I2J-1G_Root--Watchtower",
  "Title": "I2J-1G_Title",
  "UpdatedAt": "I2J-1G_UpdatedAt",
  "skeleton-loading": "I2J-1G_skeleton-loading",
});
